import { handleActions } from 'redux-actions'
import initialState from '../initialState'

const SET_CURRENT_THEME = 'SET_CURRENT_THEME'

// Update the current Theme in Redux
export const setCurrentTheme = (theme) => ({
  type: SET_CURRENT_THEME,
  payload: {
    currentTheme: theme || 'DEFAULT',
  },
})

export default handleActions(
  {
    [SET_CURRENT_THEME]: (state, { payload }) => ({
      ...state,
      current: payload, // Update the current Theme in Redux like { currentTheme: payload }
    }),
  },

  initialState.themes
)
